import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FuncaoService, Licitacao } from 'eddydata-lib';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: 'lib-bb-licitacoes-e',
  templateUrl: './bb-licitacoes-e.component.html',
  styleUrls: ['./bb-licitacoes-e.component.css']
})
export class BBLicitacoesEComponent implements OnInit, OnDestroy {

  @Input() entidade: Licitacao;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    private funcaoService: FuncaoService
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public exportarAOP711() {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.gerarTexto()));
    element.setAttribute('download', `${this.entidade.numero}_BB.txt`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  private gerarTexto(): string {
    let arquivo = '';

    // HEADER
    arquivo += '00000000000'; // FILLER	X(011)	1	11	Informado 00000000000    
    arquivo += 'AOP711'; // Nome do padrão do Arquivo	X(006)  	12	17	Informado AOP711    
    arquivo += '  '; // FILLER	X(002)	18	19	Preencher com espaços    
    arquivo += this.funcaoService.strZero(new Date().getDate(), 2); // Dia do arquivo (DD)	9(002)	20	21	Informar no formato DD    
    arquivo += this.funcaoService.strZero(new Date().getMonth() + 1, 2); // Mês do arquivo (MM)	9(002)	22	23	Informar no formato MM    
    arquivo += new Date().getFullYear(); // Ano do arquivo (AAAA)	9(004)	24	27	Informar no formato AAAA    
    arquivo += '  '; // FILLER	X(002)	28	29	Preencher com espaços
    arquivo += '900039320'; // Código do cliente na base corporativa - MCI	9(009)	30	38	Código interno do BB, criado quando do cadastramento do orgão.Solicitar o número à agência de relacionamento.
    arquivo += '  '; // FILLER	X(002)	39	40	Preencher com espaços
    arquivo += '000000026'; // Código identificador BB do convênio de troca de arquivo	9(009)	41	49	Informar (000000026)
    arquivo += '  '; // FILLER	X(002)	50	51	Preencher com espaços
    arquivo += '900039320'; // Código do convênio do cliente no IED e AOP	9(009)	52	60	Código interno do BB, gerado quando do cadastramento no aplicativo LICIT. Solicitar o número à agência de relacionamento.
    arquivo += ' '; // FILLER	X(001)	61	61	Preencher com espaço
    arquivo += ''; // Texto de descrição do convênio	X(120)	62	181	(vazio)
    arquivo += ''; // Número de remessa do IED	9(009)	182	190	Número gerado pelo comprador, seqüêncial, iniciando em 01.
    arquivo += ''; // FILLER	X(835)	191	1025	Preencher com espaços
    arquivo += '\n';

    // REGISTRO TIPO 1 - LICITAÇÃO
    arquivo += '01'; // Tipo de registro	9(002)       	1	2	Informar 01
    arquivo += this.funcaoService.strZero(this.entidade.id, 9); // Identificador da licitação (PK do cliente)	9(009)       	3	11	Número composto a critério do comprador, iniciado pelo código da Unidade Organizacional mais o identificador numérico da licitação
    arquivo += '900039320'; // Código BB do comprador 	9(009)       	12	20	Informado o mesmo código do campo "12" do HEADER
    arquivo += '900039320'; // Código BB da Unidade Organizacional	9(009)	21	29	Código gerado pelo BB, quando do cadastrameto da Unidade no sistema . Solicitar o número à agência de relacionamento. 
    arquivo += '0002'; // Código BB modalidade da licitação	9(004)	30	33	Informar (0001) para dispensa ; (0002) para pregão; (0003) para convite; (0004) para cotação de preços
    arquivo += '0001'; // Código BB do tipo de licitação 	9(004)	34	37	Informar (0001)
    arquivo += '0103'; // Código BB da moeda	9(004)	38	41	Informar (0103) para Real
    arquivo += this.funcaoService.strZero(this.entidade.numero, 10); // Número do edital	X(010)	42	51	Número gerado pelo comprador 
    arquivo += this.funcaoService.strZero(this.entidade.numero, 10); // Número do processo 	X(020)	52	71	Número gerado pelo comprador
    arquivo += this.funcaoService.converteDataBR(this.entidade.data_publicacao ? this.entidade.data_publicacao : new Date()); // Data de publicação do edital no Diário Oficial da União(DOU)	X(010)	72	81	Informar no formato DD.MM.AAAA (incluir separadores)
    arquivo += new Date().toISOString(); // Timestamp de início de entrega das propostas 	X(026)	82	107	Formato AAAA-MM-DD-HH.MM.SS.MMMMMM (Ano.Mês.Dia.Hora.Minuto.Segundo.Milissegundo)
    arquivo += new Date().toISOString(); // Timestamp de fim de entrega das propostas	X(026)	108	133	Formato AAAA-MM-DD-HH.MM.SS.MMMMMM (Ano.Mês.Dia.Hora.Minuto.Segundo.Milissegundo)
    arquivo += new Date().toISOString(); // Timestamp de abertura das propostas 	X(026)	134	159	Formato AAAA-MM-DD-HH.MM.SS.MMMMMM (Ano.Mês.Dia.Hora.Minuto.Segundo.Milissegundo)
    arquivo += new Date().toISOString(); // Timestamp de início do pregão	X(026)	160	185	Formato AAAA-MM-DD-HH.MM.SS.MMMMMM (Ano.Mês.Dia.Hora.Minuto.Segundo.Milissegundo)
    arquivo += this.funcaoService.strZero(30, 4); // Prazo para apresentação de recurso (dias)	9(004)	186	189	Informar a quantidade de dias, completando com zero à esquerda
    arquivo += '0001'; // Código BB da forma de participação	9(004)	190	193	Informar (0001) para amplo; (0002) para restrito; (0003) restrito por categoria; (0004) para selecionados 
    arquivo += '0001'; // Código BB do idioma princpal	9(004)	194	197	Informar (0001) para Português
    arquivo += ''; // FILLER	X(828)	198	1025	Preencher com espaços.
    arquivo += '\n';

    // REGISTRO TIPO 2 - TEXTO DA LICITAÇÃO
    arquivo += '02'; // Tipo de registro	9(002)       	1	2	Informar 02
    arquivo += this.funcaoService.strZero(this.entidade.id, 9); // Identificador da licitação (PK do cliente)	9(009)       	3	11	Informar o mesmo número constante no campo "02" do registro tipo 01, de acordo com a respectiva licitação.
    arquivo += '0001'; // Código BB do idioma do texto	9(004)	12	15	Informar (0001) para Português
    arquivo += this.funcaoService.abreviarStr(this.entidade.objeto, 1000); // Texto de descrição da licitação	X(1000)	16	1015	Informar resumidamente do que se trata a licitação, atentando para o limite de caracteres.
    arquivo += ''; // FILLER	X(010)	1016	1025	Preencher com espaços.
    arquivo += '\n';

    this.entidade.itens.forEach(memorial => {
      // REGISTRO TIPO 3 - LOTE DA LICITAÇÃO
      arquivo += '03'; //Tipo de registro	9(002)       	1	2	Informar 03
      arquivo += this.funcaoService.strZero(this.entidade.id, 9); //Identificador da licitação (PK do cliente)	9(009)       	3	11	Informar o mesmo número constante no campo "02" do registro tipo 01, de acordo com a respectiva licitação.
      arquivo += this.funcaoService.strZero(memorial.id, 4); //Identificador do lote da licitação (PK do cliente)	9(004)	12	15	Número gerado pelo comprador
      arquivo += '9999'; //Tempo em minutos de disputa	9(004)	16	19	Informar a quantidade de minutos que a disputa terá (tempo regulamentar), para licitação com disputa em sessão pública
      arquivo += '0002'; //Código BB de critério de seleção de propostas 	9(004)	20	23	Informar (0002)
      arquivo += '0002'; //Código BB do tipo de disputa 	9(004)	24	27	Informar (0002) para "com disputa em sessão pública"; (0003) para "sem disputa - proposta única";(0004) para "com disputa sem sessão pública"
      arquivo += ''; //FILLER	X(998)	28	1025	Preencher com espaços.
      arquivo += '\n';

      // REGISTRO TIPO 4 - TEXTO DO LOTE DA LICITAÇÃO
      arquivo += '04'; // Tipo de registro	9(002)       	1	2	Informar 04
      arquivo += this.funcaoService.strZero(this.entidade.id, 9); // Identificador da licitação (PK do cliente)	9(009)       	3	11	Informar mesmo número constante do campo "02" do registro tipo 01, de acordo com a respectiva licitação
      arquivo += this.funcaoService.strZero(memorial.id, 4); // Identificador do lote da licitação (PK do cliente)	9(004)       	12	15	Informar mesmo número constante do campo "03" do registro tipo 03
      arquivo += '0001'; // Código BB do idioma do texto	9(004)	16	19	Informar (0001) para Português
      arquivo += this.funcaoService.abreviarStr(memorial.descricao, 1000); // Texto de descrição do lote da licitação	X(1000)	20	1019	Descrever resumidamente o conteúdo do lote
      arquivo += ''; // FILLER	X(006)  	1020	1025	Preencher com espaços.
      arquivo += '\n';

      // REGISTRO TIPO 5 - ITEM DA LICITAÇÃO
      arquivo += '05'; //Tipo de registro	9(002)       	1	2	Informar 05
      arquivo += this.funcaoService.strZero(this.entidade.id, 9); //Identificador da licitação (PK do cliente)	9(009)       	3	11	Informar mesmo número constante do campo "02" do registro tipo 01, de acordo com a respectiva licitação
      arquivo += this.funcaoService.strZero(memorial.id, 4); //Identificador do lote da licitação (PK do cliente)	9(004)       	12	15	Informar mesmo número constante do campo "03" do registro tipo 03
      arquivo += this.funcaoService.strZero(memorial.id, 4); //Identificador do item da licitação (PK do cliente)	9(004)	16	19	Número gerado pelo comprador
      arquivo += '000000000'; //Código BB da mercadoria 	9(009)	20	28	Código fornecido através do arquivo AOP714, gerado a partir do AOP713
      arquivo += '0000'; //Código BB do produto	9(004)	29	32	Código fornecido através do arquivo AOP714 (opcional), gerado a partir do AOP713. Se não informado, preencher com (0000)
      arquivo += this.funcaoService.strZero(+memorial.quantidade, 15); //Quantidade de itens a adquirir	9(015)	33	47	Informar a quantidade de itens, preenchendo o campo com zeros à esquerda
      arquivo += ''; //FILLER	X(978)	48	1025	Preencher com espaços.
      arquivo += '\n';

      // REGISTRO TIPO 6 - TEXTO DO ITEM DA LICITAÇÃO
      arquivo += '06'; //Tipo de registro	9(002)       	1	2	Informar 06
      arquivo += this.funcaoService.strZero(this.entidade.id, 9); //Identificador da licitação (PK do cliente)	9(009)       	3	11	Informar o mesmo número constante no campo "02" do registro tipo 01, de acordo com a respectiva licitação.
      arquivo += this.funcaoService.strZero(memorial.id, 4); //Identificador do lote da licitação (PK do cliente)	9(004)	12	15	Informar o mesmo número constante no campo "03" do registro tipo 03
      arquivo += this.funcaoService.strZero(memorial.id, 4); //Identificador do item da licitação (PK do cliente)	9(004)	16	19	Informar o mesmo número constante no campo "04" do registro tipo 05
      arquivo += '0001'; //Código BB do idioma do texto	9(004)	20	23	Informar (0001) para Português
      arquivo += this.funcaoService.abreviarStr(memorial.descricao, 1000); //Texto de descrição do item da licitação	X(1000)	24	1023	Descrever minuciosamente o conteúdo do item
      arquivo += ''; //FILLER	X(02)	1024	1025	Preencher com espaços.
      arquivo += '\n';
    })

    return arquivo;
  }

}
